if(typeof require !== 'undefined'){
  MailtoFactory = require('../mailtos/mailto-factory.js');
  _ = require('lodash');
}

class MlsProInviteMailtoString extends MailtoFactory{

  constructor(options){
    if(!options.rea || !options.agent)
      console.warn('Rea and Agent are required for mailto.');

    super(options);
  }

  _to(){
    return this.rea.email;
  }

  _subject(){
    return `Our clients (e.g. ${this._getClientNamesForSubject()}) on Homebot`;
  }

  _getClientNamesForSubject(){
    return this._getClientNames()[0];
  }

  _getClientNamesForBody(){
    return this._getClientNames()
      .slice(0,5)
      .join(', ');
  }

  _getClientNames(){
    return this.rea.homes.map((home) => {
      return `${home.users[0].first_name} ${home.users[0].last_name}`;
    });
  }

  _body(){
    return `Hi ${this.rea.first_name},

I'm providing a new service called Homebot to all of my clients (and they love it). It monitors their home value, loans, and market conditions to optimize home finance decisions (e.g. when to refi, when to buy/sell/rent, etc). Click on this link to see what it looks like (http://get.homebotapp.com/agent/)

I wanted to give you a heads up because we share the following clients that are getting Homebot: ${this._getClientNamesForBody()}

Homebot lets the client request an updated home value and when they do, I forward that request to you.  It's great for new listings/referrals and keeping you from getting "Zillow'd" with your existing clients!

Here's a link for more information (http://www.homebot.ai) or just give me a buzz anytime.   There's also a version for real estate agents and if you're interested, I'd be happy to co-sponsor it for you!

${this.agent.first_name} ${this.agent.last_name}`;
  }

}


if(typeof module !== 'undefined' && module.exports)
  module.exports = MlsProInviteMailtoString;
else if(typeof window !== 'undefined')
  window.MlsProInviteMailtoString = MlsProInviteMailtoString;
